<script>
export default {
  name: 'c-widget-input-switch',
  props: {
    description: {
      type: String
    },
    label: {
      type: String
    },
    ariaLabel: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Boolean]
    },
    options: {
      type: Array
    }
  },
  render(h) {
    const radioProps = {
      buttons: true,
      'button-variant': 'primary',
      checked: this.value,
      disabled: this.disabled
    };

    if (this.$slots.default === undefined) {
      radioProps.options = this.options;
    }

    return h(
      'v-form-group',
      {
        class: 'c-widget-input-switch',
        props: { label: this.label, description: this.description }
      },
      [
        h(
          'v-form-radio-group',
          {
            attrs: { 'aria-label': this.ariaLabel },
            props: radioProps,
            on: { input: $event => this.$emit('input', $event) }
          },
          this.$slots.default ? this.$slots.default : []
        )
      ]
    );
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-widget-input-switch';
</style>
